export default __webpack_public_path__ + "static/media/3Vid.1e6e4eba.mp4";